<!-- eslint-disable -->
<template>
    <v-container fluid>
        <v-row no-gutters>
            <!-- LEFT TABLE -->
            <v-col xs="4" sm="4" md="4" lg="4" xl="4" align-content-start elevation-2 style="border-right: 8px solid #F4F7FA;">
                <!-- HEADER -->
                <v-row no-gutters v-if="displayContent && options.header.length > 0">
                    <template v-for="(val, key) in options.header">
                        <v-col v-if="key < options.freeze" :key="key" hidden-sm-and-down style="border-bottom: 1px solid #BDBDBD;">
                            <v-card height="69" tile flat color="white">
                                <v-card-text class="caption text-xs-center font-weight-medium align-center justify-center fill-height pt-4">
                                    {{ val.text }}
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </template>
                </v-row>
                <!-- BODY -->
                <template v-if="data.length > 0">
                    <v-row no-gutters v-for="(val, key) in data" :key="key" >
                        <template v-for="(valHeader, keyHeader) in options.header">
                            <v-col v-if="keyHeader < options.freeze" :key="keyHeader" hidden-sm-and-down :class="{'br-1': keyHeader+1 !== options.freeze}">
                                <v-card height="50" tile flat :color="key % 2 == 1 ? `grey lighten-2` : `white`">
                                    <v-card-text class="caption text-xs-center">{{ val[valHeader.value] }}</v-card-text>
                                </v-card>
                            </v-col>
                        </template>
                    </v-row>
                </template>
            </v-col>

            <!-- RIGHT TABLE -->
            <v-col cols="8" class="horiz-scroll" elevation-2>
                <!-- HEADER -->
                <div class="d-flex flex-row flex-nowrap" no-gutters v-if="displayContent && options.header.length > 0">
                    <template v-for="(val, key) in options.header">
                        <div v-if="key >= options.freeze" :key="key" class="d-flex" 
                            style="border-bottom: 1px solid #BDBDBD;" 
                            :class="{'br-1': options.header.length-1 !== key}"
                        >
                            <v-card height="69" width="100" tile flat color="white">
                                <v-card-text class="caption text-xs-center font-weight-medium align-center justify-center fill-height pt-4">
                                    {{ val.text }}
                                </v-card-text>
                            </v-card>
                        </div>
                    </template>
                </div>
                <!-- BODY -->
                <template v-if="data.length > 0">
                    <div class="d-flex flex-row flex-nowrap" no-gutters v-for="(val, key) in data" :key="key" >
                        <template v-for="(valHeader, keyHeader) in options.header">
                            <div v-if="keyHeader >= options.freeze" :key="keyHeader" class="d-flex flex-nowrap" :class="{'br-1': options.header.length-1 !== keyHeader}">
                                <v-card height="50" width="100" tile flat :color="key % 2 == 1 ? `grey lighten-2` : `white`">
                                    <v-card-text class="caption">{{ val[valHeader.value] }}</v-card-text>
                                </v-card>
                            </div>
                        </template>
                    </div>
                </template>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
	props: {
		data: {
			type: Array,
			default: () => {
				return []
			}
		},
		options: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			displayContent: true
		}
	}

	// computed: {
	//     displayContent(){
	//         if(this.attendances.length > 0 && !this.loading){
	//             return true
	//         }
	//         else if(this.attendances.length == 0 && !this.loading){
	//             return false
	//         }
	//     }
	// }
}
</script>

<style scoped>
.horiz-scroll {
	overflow-y: hidden;
	overflow-x: auto;
}
/* .c-shift-input {
	border: 1px solid #bdbdbd;
	height: 20px;
	width: 20px;
}
.button-navigation {
	position: fixed;
	right: 23px;
	z-index: 1;
	bottom: 0;
} */
.br-1 {
	border-right: 1px solid #bdbdbd;
}
</style>
